export const VERIFY_DEALER_BEGIN = "verify_dealer_begin"
export const VERIFY_DEALER_SUCCESS = "verify_dealer_success"
export const SIGN_IN_DEALER_SUCCESS = "sign_in_dealer_success"